import LeadsChartContainer from "./LeadsChartContainer";

const BarGraphContainer = () => {
    return (
        <div>
            <LeadsChartContainer />
        </div>
    );
}

export default BarGraphContainer;